import React, { useState, useEffect } from 'react';
import './Navbar.css';

export default function Navbar({ theme, onToggleTheme }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    { href: '#about',      label: 'About' },
    { href: '#skills',     label: 'Skills' },
    { href: '#projects',   label: 'Projects' },
    { href: '#experience', label: 'Experience' },
    { href: '#contact',    label: 'Contact' },
  ];

  const handleLink = (href) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
      <div className="nav-logo">
        Shakeel<span className="logo-dot">.</span>
      </div>

      {/* Desktop links */}
      <ul className="nav-links">
        {navLinks.map(l => (
          <li key={l.href}>
            <button onClick={() => handleLink(l.href)}>{l.label}</button>
          </li>
        ))}
      </ul>

      <div className="nav-right">
        <button
          className="theme-btn"
          onClick={onToggleTheme}
          aria-label="Toggle theme"
          title="Toggle theme"
        >
          {theme === 'light' ? '🌙' : '☀️'}
        </button>
        <button className="nav-cta" onClick={() => handleLink('#contact')}>
          Hire Me
        </button>

        {/* Hamburger */}
        <button
          className={`hamburger${menuOpen ? ' open' : ''}`}
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Menu"
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="mobile-menu">
          {navLinks.map(l => (
            <button key={l.href} onClick={() => handleLink(l.href)}>
              {l.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
